<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 20.6744L22 12.3372L2 4V10.6698L15.3302 12.3372L2 14.0046L2 20.6744Z" fill="#8E8E93"/>
    </svg>
</template>

<script>
    export default {
        name: "Send"
    }
</script>

<style scoped>

</style>